/**
 *
 * Asynchronously loads the JobsStagesFilterPopup component
 *
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
